import * as yup from 'yup';

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email('login.errors.email').required('common.required'),
});

export default forgotPasswordSchema;
